import { createApp } from 'vue';
import TrackingCapture from '@/components/TrackingCapture.vue';

const app = createApp({});
app.component('TrackingCapture', TrackingCapture);
app.mount('#trackingCaptureApp');
